export default function Search({
  handleSearch,
  handleSearching,
  handleKey,
  placeholder,
}) {
  return (
    <div className="input-group search-contacts">
      <input
        type="Search"
        className="form-control"
        placeholder={placeholder}
        onChange={handleSearch}
        onKeyDown={handleKey}
      />
      <i onClick={handleSearching} className="fa fa-search" aria-hidden="true"></i>
    </div>
  );
}
